import { Button, Card, CardContent, CardHeader, Chip, Divider, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@material-ui/core'
import React from 'react'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { toFarsiDigits } from '../../assets/utils'
import { contractorsState } from '../../pages/department/atoms'
import api from '../../api/client'
import RowActions from '../common/RowActions'
import Pagination from '../common/Pagination';
import { beginImpersonation } from '../../api/impersonation';
import { userInfoState } from '../../recoil/atoms'

const useStyles = makeStyles(theme => ({
    root: {
        background: '#f1f1f1',
        flexGrow: 1,
        marginBottom: theme.spacing(6)
    },
}))

const loginHandler = (id, setUserInfo, currentUser) => {
    beginImpersonation(currentUser)
    api.post('users/login/' + id).then(result => {
        if (result.status === 200) {
            setUserInfo(result.data.user)
            localStorage.setItem('access', result.data.tokens.access)
            // جلوگیری از برگشتِ رفرشِ بعدی به حساب قبلی
            if (result.data.tokens.refresh) {
                localStorage.setItem('refresh', result.data.tokens.refresh)
            }
            api.defaults.headers.common['Authorization'] = 'Bearer ' + result.data.tokens.access
        }
    })
}

const Contractors = props => {
    const setUserInfo = useSetRecoilState(userInfoState)
    const userInfo = useRecoilValue(userInfoState)
    const classes = useStyles()
    const contractors = useRecoilValue(contractorsState)
    return (
        <Card elevation={5} className={classes.root}>
            <CardHeader
                title='پیمانکاران'
            />
            <Divider />
            <CardContent>
                <TableContainer elevation={5} component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align='center'><strong>ردیف</strong></TableCell>
                                <TableCell align='center'><strong>نام</strong></TableCell>
                                <TableCell align='center'><strong>قرارداد</strong></TableCell>
                                <TableCell align='center'><strong>حواله در یکسال گذشته</strong></TableCell>
                                <TableCell align='center'><strong>شماره ثبت</strong></TableCell>
                                <TableCell align='center'><strong>شناسه ملی</strong></TableCell>
                                <TableCell align='center'><strong>کد اقتصادی</strong></TableCell>
                                <TableCell align='center'><strong>کد معاملاتی</strong></TableCell>
                                <TableCell align='center'><strong>ورود به عنوان پیمانکار</strong></TableCell>
                                <TableCell align='center'><strong>پیام</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {contractors.contractors.map((row, index) => (
                                <TableRow key={row.id}>
                                    <TableCell align='center'><strong>{toFarsiDigits(row.number)}</strong></TableCell>
                                    <TableCell align='center'>{toFarsiDigits(row.name)}</TableCell>
                                    <TableCell align='center'><Chip size='small' label={toFarsiDigits(row.contracts_count ?? 0)} style={{ background: '#e8eaf6', fontWeight: 700 }} /></TableCell>
                                    <TableCell align='center'><Chip size='small' label={toFarsiDigits(row.transfers_year ?? 0)} style={{ background: '#e0f2f1', fontWeight: 700 }} /></TableCell>
                                    <TableCell align='center'>{toFarsiDigits(row.registration_number)}</TableCell>
                                    <TableCell align='center'>{toFarsiDigits(row.national_code)}</TableCell>
                                    <TableCell align='center'>{toFarsiDigits(row.economic_code)}</TableCell>
                                    <TableCell align='center'>{toFarsiDigits(row.brokerage_account)}</TableCell>
                                    <TableCell align='center'>
                                        ‌<Button
                                            variant='contained'
                                            color='primary'
                                            onClick={() => loginHandler(row.id, setUserInfo, userInfo)}
                                        >
                                            ورود
                                        </Button>
                                    </TableCell>
                                    <TableCell align='center'>
                                        <RowActions userId={row.userid} mobile={row.mobile} name={row.name} />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <Pagination
                        page={(props.page || 0) + 1}
                        pages={Math.ceil((contractors.summary.count || 0) / (props.rowsPerPage || 10))}
                        onChange={(p) => props.onChangePage(null, p - 1)}
                        extra={(
                            <select
                                value={props.rowsPerPage}
                                onChange={props.onChangeRowsPerPage}
                                style={{
                                    height: 30, borderRadius: 8, border: '1px solid #c5cae9',
                                    background: '#fff', color: '#3949ab', fontSize: 12.5, padding: '0 6px',
                                }}
                            >
                                {[10, 20, 30, 40, 50].map((n) => (
                                    <option key={n} value={n}>{toFarsiDigits(n)} در صفحه</option>
                                ))}
                            </select>
                        )}
                    />
                </TableContainer>
            </CardContent>
        </Card>
    )
}

export default Contractors